import "./../../../bindings/bao-searcher";
import "./../../../bindings/bao-toolbar2";
import * as $ from "jquery";
import GenericListSearchTab from "./../../../factories/generic-list-search-tab";
//import ko = window.baorequire("ko");
//import Bao = window.baorequire("Bao");
class UserMandatorTab extends GenericListSearchTab {
    SearchType(): string {
        return "Uadm-Mandator";
    }
    ItemCompleteCheck(item: any): JQueryPromise<boolean> {
        return $.Deferred<boolean>().resolve(true).promise();
    }
    CustomFilter(): Models.HashObject[] {
        return null;
    }
}
export default UserMandatorTab;